export default __webpack_public_path__ + "static/media/average_vist.b310e9f8.png";